import type { CSSProperties } from 'react'

const BRAND_ASSET_ROOT = '/brand'

export const avertsignalBrandAssets = {
  fullColor: `${BRAND_ASSET_ROOT}/AvertSignal_Primary_Horizontal_FullColor.svg`,
  reversed: `${BRAND_ASSET_ROOT}/AvertSignal_Primary_Horizontal_Reversed.svg`,
  // Current approved AvertSignal circuit-style monogram (the PWA/app icon
  // geometry). The legacy concentric mark is no longer used in active UI.
  mark: `${BRAND_ASSET_ROOT}/icon-192-navy.png`,
} as const

type MarkProps = {
  size?: number
  className?: string
  title?: string
  style?: CSSProperties
}

export function AvertSignalMark({ size = 42, className = '', title = 'AvertSignal', style }: MarkProps) {
  return <img
    className={`avertsignal-mark ${className}`}
    src={avertsignalBrandAssets.mark}
    alt={title}
    width={size}
    height={size}
    style={style}
  />
}

export function AvertSignalLockup({
  compact = false,
  subtitle = 'FROM FIRST SIGNAL TO VERIFIED RESOLUTION',
  markSize = 42,
}: {
  compact?: boolean
  subtitle?: string
  markSize?: number
}) {
  return <div className={`avertsignal-lockup ${compact ? 'compact' : ''}`}>
    <AvertSignalMark className="avertsignal-lockup-mark" size={markSize} />
    <div className="avertsignal-lockup-copy">
      <img className="avertsignal-logo avertsignal-logo-reversed" src={avertsignalBrandAssets.reversed} alt="AvertSignal" />
      <img className="avertsignal-logo avertsignal-logo-full-color" src={avertsignalBrandAssets.fullColor} alt="" aria-hidden="true" />
      {!compact && subtitle && <small>{subtitle}</small>}
    </div>
  </div>
}
